import { BaseUseCase } from "../UseCaseBase";
class WebinarUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getWebinarData();
    }
}
export default WebinarUseCase;
